import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ChevronLeft, Loader2, GraduationCap, PlayCircle, BookOpen, Award, FlaskConical } from "lucide-react";
import { fetchMisCursos, descargarCertificado } from "../lib/academia";
import { toast } from "sonner";

const BACKEND = process.env.REACT_APP_BACKEND_URL || "";

function fmtFecha(iso) {
  if (!iso) return "";
  return new Date(iso).toLocaleDateString("es-PE", { day: "2-digit", month: "short", year: "numeric" });
}

export default function MisCursos() {
  const [items, setItems] = useState(null);
  const [busy, setBusy] = useState(null);
  useEffect(() => { fetchMisCursos().then((d) => setItems(d.items || [])).catch(() => setItems([])); }, []);

  async function bajarCert(e, cid) {
    e.preventDefault(); e.stopPropagation();
    setBusy(cid);
    try { await descargarCertificado(cid); toast.success("Generando tu certificado…"); }
    catch { toast.error("No se pudo generar el certificado."); }
    finally { setBusy(null); }
  }

  return (
    <div className="px-5 md:px-8 py-8" data-testid="mis-cursos-page">
      <Link to="/academia" className="inline-flex items-center gap-1 text-sm font-semibold text-slate-500 hover:text-slate-800">
        <ChevronLeft size={16} /> Volver a la Academia
      </Link>
      <div className="mt-4 flex items-center gap-3">
        <span className="w-11 h-11 rounded-xl flex items-center justify-center" style={{ backgroundColor: "#EA580C1a", color: "#EA580C" }}><GraduationCap size={22} /></span>
        <div>
          <h1 className="text-2xl font-extrabold text-slate-900 tracking-tight">Mis Cursos</h1>
          <p className="text-sm text-slate-500">Continúa aprendiendo. Tus cursos están disponibles para siempre.</p>
        </div>
      </div>

      <div className="mt-5 flex items-center gap-3 flex-wrap">
        <Link to="/academia/mis-certificados" data-testid="descargar-mis-certificados-btn"
          className="inline-flex items-center gap-2 bg-amber-400 hover:bg-amber-300 text-slate-900 font-bold px-5 py-2.5 rounded-xl transition-colors">
          <Award size={17} /> Descargar mis Certificados
        </Link>
        <Link to="/academia/mis-certificados" data-testid="ver-prueba-link"
          className="inline-flex items-center gap-2 border border-amber-400 text-amber-700 hover:bg-amber-50 font-semibold px-5 py-2.5 rounded-xl transition-colors">
          <FlaskConical size={16} /> Ver Certificado de Prueba
        </Link>
      </div>

      {items === null ? (
        <div className="mt-10 flex items-center gap-2 text-slate-500"><Loader2 className="animate-spin" size={18} /> Cargando…</div>
      ) : items.length === 0 ? (
        <div className="mt-10 bg-white rounded-2xl border border-slate-100 shadow-soft p-10 text-center" data-testid="mis-cursos-vacio">
          <BookOpen size={40} className="mx-auto text-slate-300" />
          <h3 className="mt-4 text-lg font-bold text-slate-900">Aún no tienes cursos</h3>
          <p className="mt-1 text-sm text-slate-500">Explora el catálogo de la Academia y empieza a formarte.</p>
          <Link to="/academia" className="mt-6 inline-flex items-center gap-2 bg-brand-navy hover:bg-brand-blue text-white font-semibold px-5 py-2.5 rounded-xl transition-colors">Ir a la Academia</Link>
        </div>
      ) : (
        <div className="mt-8 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {items.map((c) => (
            <Link key={c.id} to={`/academia/curso/${c.id}`} className="bg-white rounded-2xl border border-slate-100 shadow-soft overflow-hidden hover:shadow-lifted transition-shadow" data-testid={`curso-item-${c.id}`}>
              <div className="h-36 bg-slate-100 flex items-center justify-center">
                {c.tiene_imagen ? <img src={`${BACKEND}/api/academia/${c.id}/imagen`} alt={c.titulo} className="w-full h-full object-cover" /> : <GraduationCap size={40} className="text-slate-300" />}
              </div>
              <div className="p-4">
                <h3 className="font-bold text-slate-900">{c.titulo}</h3>
                <p className="text-xs text-slate-500 mt-1">{c.num_modulos} módulos · {c.num_lecciones} lecciones</p>
                <p className="text-xs text-slate-400 mt-1">Inscrito el {fmtFecha(c.inscrito_el)}</p>
                <div className="mt-3 flex items-center justify-between gap-2">
                  <span className="inline-flex items-center gap-1.5 text-sm font-semibold" style={{ color: "#EA580C" }}><PlayCircle size={15} /> {c.completado ? "Repasar" : "Continuar"}</span>
                  {c.completado && (
                    <button onClick={(e) => bajarCert(e, c.id)} disabled={busy === c.id} data-testid={`cert-btn-${c.id}`} className="inline-flex items-center gap-1.5 bg-amber-400 hover:bg-amber-300 text-slate-900 font-bold text-xs px-3 py-1.5 rounded-lg transition-colors disabled:opacity-60">
                      {busy === c.id ? <Loader2 size={13} className="animate-spin" /> : <Award size={13} />} Certificado
                    </button>
                  )}
                </div>
                {typeof c.progreso_total === "number" && (
                  <div className="mt-2 h-1.5 rounded-full bg-slate-100 overflow-hidden">
                    <div className="h-full" style={{ width: `${c.progreso_total}%`, backgroundColor: c.completado ? "#16A34A" : "#EA580C" }} />
                  </div>
                )}
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
